import React from "react";
import { Link } from "react-router-dom";

const Footer = (props) => {
  return (
    <footer className={`wpo-site-footer ${props.footerClass}`}>
      <div className="wpo-lower-footer">
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <p className="copyright">
                Copyright &copy; Neurodesenvolver<span>2025</span>
                <span className="copyright-icon">|</span> Todos os direitos
                reservados.
              </p>
            </div>
            <div className="col col-xs-12 ">
              <Link
                to="https://hub.goadopt.io/document/51802f01-d597-43f0-9f2c-e9ebed6af6f0"
                target="_blank"
                rel="noopener noreferrer"
              >
                Política de Privacidade
              </Link>
              <span className="copyright-icon">|</span>
              <Link
                to="https://hub.goadopt.io/document/bb3664ea-884e-4f13-847a-aa296008385a"
                target="_blank"
                rel="noopener noreferrer"
              >
                Termos de Uso
              </Link>
              <span className="copyright-icon">|</span>
              <Link
                to="https://hub.goadopt.io/document/6fe65eb6-14fd-46fc-b4b5-ed4c518b4321"
                target="_blank"
                rel="noopener noreferrer"
              >
                Política de Cookies
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
